export default __webpack_public_path__ + "static/media/component003Man-right.edd2fa23.png";